import { Resource } from 'i18next';
import { english } from '../locales/english.ts';
import { espanol } from '../locales/espanol.ts';

export const languages: Resource = {
  en: { translation: english },
  es: { translation: espanol },
};
